export default __webpack_public_path__ + "static/media/lifeguru4xd.6c985346.png";